<template>
	<div class="modal-overlay" :class="{ 'hide-menu-modal':isModalHidden }">
		<div class="menu-modal">
			<div class="modal-close-btn" @click="hideMenuModal">
				<div class="circle-hover"><img src="/images/close-icon.svg" class="w-100"></div>
			</div>
			<div class="menu-modal-body">
				<ul>
					<li v-for="item in moduleArray" :key="item.id">
						<router-link :to="'/'+formatToPath(moduleName)+'/'+formatToPath(item.pageName)">
							<i v-if="item.pageIcon=='Add' || item.pageIcon=='Create'" class="fa fa-plus"></i>
							<i v-else-if="item.pageIcon=='Send'" class="fas fa-paper-plane"></i>
							<i v-else-if="item.pageIcon=='Reports'" class="fa fa-chart-bar"></i>
							<i v-else class="fa fa-list-ul"></i>
							{{ item.pageName }}
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import { EventBus } from '@/event-bus.js'

export default {
	name: 'MenuModal',
	props: {

	},
	data() {
		return {
			moduleName: "",
			moduleArray: [],
			isModalHidden: true
		}
	},
	mounted(){
		EventBus.$on('show-menu-modal', (name,pages) => {
			this.moduleName = name;
			this.moduleArray = pages;
			this.showMenuModal();
		});
		EventBus.$on('hide-menu-modal', this.hideMenuModal);
	},
	methods: {
		showMenuModal: function() {
			this.isModalHidden = false;
		},
		hideMenuModal: function() {
			this.isModalHidden = true;
		}
	}
}
</script>